// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"238":"9bf1fb85","243":"d985fd2b","419":"2e0c62f0","478":"6f80ce2f","677":"dc026e5a","877":"e65a6f26","931":"7dec11f6","966":"a6347208","970":"f799bc09"}[chunkId] + ".chunk.css";
};